module.exports = __webpack_public_path__ + "static/media/alarm-no.8ff79c69.svg";